import { stepMap } from ".";
import { StepMapParams } from "../store/middlewares/utils/getStepParams";
import { Animal, State } from "../store/state/types";

export type StepName = keyof typeof stepMap;

export type Step = {
  index: number;
  name: StepName;
  isValid: (params: StepMapParams) => boolean;
  next: (params: StepMapParams, overrideStep?: StepName) => StepName;
  previous?: (params: StepMapParams) => StepName | null;
};

export type StepProps = {
  isValid: boolean;
  next: (replace?: boolean, overrideStep?: keyof typeof stepMap) => void;
  previous?: (replace?: boolean) => void;
  transitioning: boolean;
};

export enum CampaignCode {
  Lunar = "lunar",
  Eurobonus = "eurobonus",
}
